import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { ThemeTagType } from "../types";
import { ThemeTagTypeDB } from "./ThemeTagTypeDB";

export const getThemePrimaryTags= async (): Promise<ThemeTagType[]> => {
  const themeTagTypesRef = collection(db, "themeTagTypes");

  const q = query(themeTagTypesRef, orderBy("name", "asc"));
  const themeTagTypesSnapshot = await getDocs(q);

  return themeTagTypesSnapshot.docs.map((doc) =>
    new ThemeTagTypeDB(doc).toThemeTagType(),
  );
};
